import React, { useState } from "react";
import LoadingSpinner from "../../../../components/Loadder";
import { postData, getData } from "../../../../serverRequest";
import { toast, ToastContainer } from 'react-toastify';

export default function TallyForm(props) {
  const [loading, setLoading] = useState(false);
  //const [showModal, setShowModal] = useState(false);
  const [entityId, setEntityId] = useState("");
  const [owner, setOwner] = useState("");
  const [backupSize, setBackupSize] = useState("");
  const [sharedWith, setSharedWith] = useState("");
  const [backupDate, setBackupDate] = useState("");
  const [tallyBackupTime, setTallyBackupTime] = useState("");
  const [driveLink, setDriveLink] = useState("");
  const [uploadedBy, setUploadedBy] = useState("");
  const [remarks, setRemarks] = useState("");
  const [entityName, setEntityName] = useState('');
  const [totalEntities, setTotalEntities] = React.useState([]);
  const [totalAdmins, setTotalAdmins] = React.useState([]);

  const filterEntityData = (entities_data) => {
    //console.log(tickets_data);
    let totalEntity = [];
    if (entities_data) {
      for (let i = 0; i < entities_data.length; i++) {
        totalEntity.push(entities_data[i])
      }
    }


    setTotalEntities(totalEntity);
    return ({ "total": totalEntity })
  }

  const filterAdminData = (admins_data) => {
    //console.log(tickets_data);
    let openTicket = [];
    let closeTicket = [];
    let totaladmin = [];
    if(admins_data){
      for (let i = 0; i < admins_data.length; i++) {
          totaladmin.push(admins_data[i])
      }
    }
   
    setTotalAdmins(totaladmin);
    return ({ "total": totalAdmins })
  }

  React.useEffect(() => {
    async function fetchData() {
      setLoading(true);
      let resData = await getData('/api/company?admin=1')
      let entities_data = resData['data']['entities']
      console.log(entities_data);
      let entitiesData = await filterEntityData(entities_data)
      let resAdminData = await getData('/api/employee/?is_list_employee=1&company_id=' + localStorage.getItem('companyId'))
      let admins_data = resAdminData['data']['employee_data']
      console.log(admins_data);
      let adminData = await filterAdminData(admins_data)


      setLoading(false);
    }
    fetchData();


  }, [])

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    // const {
    //   id,
    //   entityId,
    //   owner,
    //   backupSize,
    //   sharedWith,
    //   backupDate,
    //   tallyBackupTime,
    //   driveLink,
    //   uploadedBy,
    //   remarks,
    // } = document.forms[0];

    const formData = {
      'entity_id': entityId || "",
      'owner': owner || "",
      'backup_size': backupSize || "",
      'shared_with': sharedWith || "",
      'backup_date': backupDate || "",
      'backup_time': tallyBackupTime || "",
      'drive_link': driveLink || "",
      'uploaded_by': uploadedBy || "",
      'remarks': remarks || "",
    };
    console.log(formData);
    try {
      const resData = await postData("/api/employee/tally_backup/", formData);

      if (resData['data']['code'] === 200) {
        setLoading(false);
        //setShowModal(true);
        toast.success("Tally Backup Created Successfully")
        window.location.href = "/admin/company/tallyList";
      } else {
        console.error("Failed to submit form:", resData.statusText);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
    }
  };

  return (
    <div className="admin-form-container p-4 min-h-screen w-full">
      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            <div className="rounded-t bg-white mb-6 px-6 py-6">
              <div className="text-center flex justify-between">
                <h6 className="text-blueGray-700 text-xl font-bold">
                  Tally Form
                </h6>
              </div>
            </div>
            <div className="flex flex-wrap justify-between">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Entity Name
                  </label>
                  <select
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="entityName"
                    value={entityId}
                    onChange={(e) => setEntityId(e.target.value)}
                  >
                    {totalEntities.map((entity, index) => (
                      <option key={index} value={entity.id}>
                        {entity.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Owner
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="owner"
                    defaultValue={owner}
                    onChange={(e) => setOwner(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Backup Size
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="backupSize"
                    defaultValue={backupSize}
                    onChange={(e) => setBackupSize(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Shared With
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="sharedWith"
                    defaultValue={sharedWith}
                    onChange={(e) => setSharedWith(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Backup Date
                  </label>
                  <input
                    type="date"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="backupDate"
                    defaultValue={backupDate}
                    onChange={(e) => setBackupDate(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Tally Backup Time (24 hours)
                  </label>
                  <input
                    type="time"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="tallyBackupTime"
                    defaultValue={tallyBackupTime}
                    onChange={(e) => setTallyBackupTime(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Drive Link
                  </label>
                  <input
                    type="url"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="driveLink"
                    defaultValue={driveLink}
                    onChange={(e) => setDriveLink(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Uploaded By
                  </label>
                  <select
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="uploadedBy"
                    defaultValue={uploadedBy}
                    onChange={(e) => setUploadedBy(e.target.value)}
                  >
                    {totalAdmins.map((admin, index) => (
                      <option key={index} value={admin.id}>
                        {admin.first_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label
                    className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                    htmlFor="grid-password"
                  >
                    Remarks
                  </label>
                  <input
                    type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="remarks"
                    defaultValue={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="text-center mt-6 lg:w-3/12 px-4">
              <input
                className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-4 w-full ease-linear transition-all duration-150"
                type="Submit"
                value="Submit"
              />
            </div>
          </div>
        </form>
      )}
      <ToastContainer />
    </div>
  );
}
